import type {Middleware} from "@reduxjs/toolkit";
import {logout, setCredentials} from "./authSlice";

export const persistAuthMiddleware: Middleware = (store) => (next) => (action) => {
  const result = next(action);

  if (setCredentials.match(action)) {
    const {accessToken, refreshToken} = action.payload;
    localStorage.setItem("accessToken", accessToken);
    localStorage.setItem("refreshToken", refreshToken);
  } else if (logout.match(action)) {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
  }
  return result;
};
